import React, {useState, useContext} from 'react';
import InputField from './components/InputField';
import {Button} from 'reactstrap';
import Header from './components/Header';
import Preview from './components/Preview';
import {getInstagramCreationPreview, createInstagramFeed} from 'utils/api';
import {textTruncateByWords} from 'utils/other';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import {ErrorContext} from 'contexts/ErrorContext';
import {useHistory} from 'react-router-dom';
import {sortObjects} from 'Helpers/sortObjects';
import SpinnerButton from 'components/SpinnerButton';

const InstagramForm = (props) => {
    let history = useHistory();

    const {handleErrors} = useContext(ErrorContext);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [creationLoading, setCreationLoading] = useState(false);
    const [feed, setFeed] = useState(null);
    const [keyword, setKeyword] = useState('');
    const [feedName, setFeedName] = useState('');
    const [accountData, setAccountData] = useState(null);

    const getPreview = async() => {
        setPreviewLoading(true);
        setFeed(null);
        try {
            const params = {
                keyword,
            };
            let source = await getInstagramCreationPreview(params);
            if(source.length > 100) {
                source = source.slice(0, 100);
            }
            setFeedName(source.content.title);
            let sortedByDate = sortObjects(source.content.news, 'publishedAt', 'desc');
            setFeed(sortedByDate);
            setAccountData({
                pagePictureUrl: source.content.pictureUrl,
                about: source.content.about,
                link: source.content.url,
                title: source.content.title,
                followersCount: source.content.followers,
                screenName: source.content.screenName,
                sourceUrl: source.content.url,
            });
            // setFeed(source.content.news);
            setPreviewLoading(false);
        } catch(err) {
            console.log(err);
            setPreviewLoading(false);
            if(err.code && err.code === 'VALIDATION_FAILED') {
                toast.error(err.message);
            } else if(err.code && err.code === 'LOGICAL_ERROR') {
                handleErrors(err);
            } else {
                toast.error('Your request contains an incorrect Instagram account name');
            }
        }
    };

    const createFeed = (value) => {
        setCreationLoading(true);
        const data = {
            keyword,
            title: feedName.trim(),
        };
        createInstagramFeed(data)
            .then(() => {
                setCreationLoading(false);
                history.push('/feeds/fetches');
            })
            .catch((err) => {
                console.log(err);
                setCreationLoading(false);
                handleErrors(err);
            });
    };

    return (
        props.auth.permissions && !props.auth.permissions.includes('social') ?
            <React.Fragment>
                <Header text="Fetch posts from Instagram"/>
                <div style={{fontSize: '18px'}}>
                    To follow Instagram accounts,<br/> contact Support to access this feature<br/>
                    <a style={{textDecoration: 'underline'}} href="mailto:support@newsfetch.io">
                        support@newsfetch.io
                    </a>
                </div>
            </React.Fragment>
            :
            <>
                <Header text="Fetch posts from Instagram"/>
                <InputField
                    showSubmitGlass={true}
                    onSubmit={getPreview}
                    loading={previewLoading}
                    inputPlaceholder="Enter the Instagram account name"
                    parrentDataHandling={true}
                    value={keyword}
                    handleChange={setKeyword}
                />
                {feed &&
                <div className="preview-container mt-3">
                    <>
                        <div className="twitter-input_container" style={{marginBottom: '10px'}}>
                            <InputField
                                onSubmit={createFeed}
                                loading={creationLoading}
                                inputPlaceholder="Enter the Newsfeed name"
                                showSubmitGlass={false}
                                parrentDataHandling={true}
                                value={feedName}
                                handleChange={setFeedName}
                            />
                            <div className="twitter-input_dropdown">
                                {/*<Button*/}
                                {/*    disabled={feedName.trim() === ''}*/}
                                {/*    style={{color: 'white', minWidth: '125px', margin: '0'}}*/}
                                {/*    onClick={createFeed}*/}
                                {/*    className="btn typical-button target_input-btn"*/}
                                {/*>*/}
                                {/*    {creationLoading ?*/}
                                {/*        <i className="fa fa-spinner fa-spin"/>*/}
                                {/*        :*/}
                                {/*        'Create Source'*/}
                                {/*    }*/}
                                {/*</Button>*/}
                                <SpinnerButton
                                    minWidth="125px"
                                    title="Create Source"
                                    submitting={creationLoading}
                                    onClick={createFeed}
                                    disabled={feedName.trim() === ''}
                                />
                            </div>
                        </div>
                        {/*{accountData &&*/}
                        {/*<div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>*/}
                        {/*    <div style={{ height: '50px', marginRight: '10px' }}>*/}
                        {/*        <img style={{ borderRadius: '50%' }} src={accountData.pagePictureUrl} alt="public page"/>*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <div style={{ fontSize: '1.1rem', fontWeight: '500' }}>{accountData.title}</div>*/}
                        {/*        {accountData.about && <div>{textTruncateByWords(accountData.about)}</div>}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*}*/}
                        <div className="mt-3">
                            <Header text="Preview"/>
                            <Preview feed={feed} sourceType="instagram"/>
                        </div>
                    </>
                </div>
                }
            </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
    null,
)(InstagramForm);
